"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import { Flash } from "../components/flash";
import ValueLinkTextDroppableInput from "./value_link_text_droppable_input";
import DisablingButton from "./disabling_button";
import paymentAddressIntegrationValidator from "./payment_address_integration_validator";
function errorElement(e) {
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "warning fi-alert" }),
    " ",
    e.field.label,
    " ",
    e.errorMessage
  ] }, e.field.label + e.errorMessage);
}
function possibleRequiredFlag(field) {
  if (field.required) {
    return /* @__PURE__ */ jsx("i", { className: "fi-asterisk required" });
  }
}
function doesFieldHaveRequiredError(state, field) {
  return field.required && s.isBlank(state[field.value]);
}
const FIELDS = [
  {
    label: "Name",
    value: "name",
    width: 12,
    required: true
  },
  {
    label: "Address Line 1",
    value: "address_line_1",
    width: 5,
    required: true
  },
  {
    label: "Address Line 2",
    value: "address_line_2",
    width: 5
  },
  {
    label: "City",
    value: "city",
    width: 5,
    required: true
  },
  {
    label: "State",
    value: "state",
    width: 2,
    required: true
  },
  {
    label: "Postal Code",
    value: "postal_code",
    width: 3,
    required: true
  },
  {
    label: "Country",
    value: "country",
    width: 10,
    required: false
  }
];
class PaymentAddressEditor extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", _.extend(
      { blurredFields: [] },
      this.props.address || {}
    ));
    __publicField(this, "mounted", false);
    __publicField(this, "integrationValidator");
    __publicField(this, "field", (field) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "small-" + field.width + " column",
          children: [
            /* @__PURE__ */ jsxs("label", { children: [
              field.label,
              " ",
              possibleRequiredFlag(field),
              this.possibleValidationIconFor(field)
            ] }),
            /* @__PURE__ */ jsx(
              ValueLinkTextDroppableInput,
              {
                type: "text",
                "data-name": field.value,
                className: this.fieldClassNames(field),
                onBlur: this.markAsBlurredHandler(field),
                maxLength: "255",
                value: this.state[field.value],
                onValueChange: (value) => this.setState({ [field.value]: value })
              }
            )
          ]
        },
        "field-" + field.value
      );
    });
    __publicField(this, "possibleErrorMessages", () => {
      const visibleFormErrors = this.visibleFormErrors().filter(
        (e) => {
          var _a;
          return !s.isBlank((_a = e.errorMessage) != null ? _a : "");
        }
      );
      if (visibleFormErrors.length > 0) {
        return /* @__PURE__ */ jsx("ul", { className: "warning", children: visibleFormErrors.map(errorElement) });
      }
    });
    __publicField(this, "markAsBlurredHandler", (field) => {
      return () => {
        this.setState({
          blurredFields: _.union(this.state.blurredFields, [field.value])
        });
      };
    });
    __publicField(this, "visibleFormErrors", () => {
      return _.chain(FIELDS).filter(this.shouldDisplayAsInvalid).map((f) => {
        return { field: f, errorMessage: this.errorMessageForField(f) };
      }).value();
    });
    __publicField(this, "possibleValidationIconFor", (field) => {
      if (this.shouldDisplayAsInvalid(field)) {
        return /* @__PURE__ */ jsxs("span", { children: [
          "\xA0",
          /* @__PURE__ */ jsx("i", { className: "warning fi-alert" })
        ] });
      }
    });
    __publicField(this, "shouldDisplayAsInvalid", (field) => {
      const hasVisibleRequiredError = this.state.blurredFields.includes(field.value) && doesFieldHaveRequiredError(this.state, field);
      return hasVisibleRequiredError || this.doesFieldHaveIntegrationValidationError(field);
    });
    __publicField(this, "doesFieldHaveIntegrationValidationError", (field) => {
      return !this.integrationValidator.validate(
        field.value,
        this.state[field.value]
      ).valid;
    });
    __publicField(this, "fieldClassNames", (field) => {
      return classNames({
        validatingFormField: true,
        invalid: this.shouldDisplayAsInvalid(field)
      });
    });
    __publicField(this, "isInvalid", () => {
      return _.any(FIELDS, _.negate(this.isFieldValid));
    });
    __publicField(this, "isFieldValid", (field) => {
      const noRequiredErrors = !doesFieldHaveRequiredError(this.state, field);
      const noIntegrationValidationError = !this.doesFieldHaveIntegrationValidationError(field);
      return noRequiredErrors && noIntegrationValidationError;
    });
    __publicField(this, "errorMessageForField", (field) => {
      return this.integrationValidator.validate(
        field.value,
        this.state[field.value]
      ).errorMessage;
    });
    __publicField(this, "saveAddress", (e) => {
      e.preventDefault();
      this.setState({ saving: true });
      this.props.saveAddress(this.state).then(
        (arg) => {
          Flash.success("Address successfully updated!");
          if (this.mounted) {
            this.setState({ saving: false });
          }
          return arg;
        },
        (arg) => {
          if (this.mounted) {
            this.setState({ saving: false });
          }
          return arg;
        }
      );
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentWillReceiveProps(props) {
    this.setState(props.address || {});
  }
  componentWillMount() {
    this.integrationValidator = paymentAddressIntegrationValidator(
      this.props.accountSettings
    );
  }
  render() {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "PaymentAddressEditor",
        className: "row",
        ref: "container",
        children: [
          this.possibleErrorMessages(),
          /* @__PURE__ */ jsxs("div", { className: "small-12 column required-legend", children: [
            /* @__PURE__ */ jsx("i", { className: "fi-asterisk required" }),
            " Required fields"
          ] }),
          /* @__PURE__ */ jsxs("form", { onSubmit: this.saveAddress, children: [
            _.map(FIELDS, this.field),
            /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
              DisablingButton,
              {
                className: "expand button--confirmation",
                disabledText: this.isInvalid() ? "Enter all fields to save" : "Saving...",
                disabled: this.state.saving || this.isInvalid(),
                children: "Save Address"
              }
            ) })
          ] })
        ]
      }
    );
  }
}
export default PaymentAddressEditor;
